import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { Banner } from "../../shared/models/banner";
import { AuthorizationService } from "../authorization/authorization.service";
import { WindowRef } from '../../utils/window';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { MatTableModule } from "@angular/material/table";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSort, MatSortModule } from "@angular/material/sort";



@Component({
    selector: "div.dtf-paymentoptions",
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ],
    templateUrl: './paymentoptions.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class PaymentOptionsComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  currentCountry: string;
  language = '';
  targetRedirect = '';
  usUrl: string;
  caUrl: string;
  toggleOpen: any;
  public alerts: Banner;
  dbData: any;

  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public dtfhomepageService: DTFHomepageService,
    public translateUtil: TranslateUtil
  ) {
    this.router = router;
}
  ngOnInit() {
    const language = (window as any).mbfs.language;
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
    //this.getAlerts();
    this.langInit();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //       for (var i = 0; i < res.length; i++) {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     });
  // }


}
